
export default {

  namespaced: true,

  state: {
    inSignupProcess: false,
    compilingPageAttributes: null,
    selectedShows: {},
  },

  mutations: {
    setInSignupFlag: function (state, variant) {
      state.inSignupProcess = variant;
    },
    setCompilingPageAttributes: function (state, pageAttributes) {
      state.compilingPageAttributes = pageAttributes;
    },
    setSelectedShows: function (state, selectedShows) {
      state.selectedShows = selectedShows;
    },
  },

  actions: {
    setInSignupFlag({ commit }) {
      commit("setInSignupFlag", true)
    },

    loadCompilingPageAttributes({ commit }) {
      return new Promise((resolve, reject) => {
        this.$spicker_service.getCompilingPageAttributes().then((res) => {
          if (res.success) {
            commit("setCompilingPageAttributes", res.data.page_attributes);
            resolve(res);
          }
        }).catch((err) => {
          reject(err);
        });
      });
    }
  },

  getters: {
    inSignupProcess: state => {
      return state.inSignupProcess;
    },
    compilingPageAttributes: state => {
      return state.compilingPageAttributes;
    },
    selectedShows: state => {
      return state.selectedShows;
    }
  }

}
